import { deleteToken } from 'firebase/messaging';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

import { deletePushToken } from './delete-push-token';
import { getPushNotificationToken, initPushNotifications } from './helpers';

// firebase JS messaging has no installations reset — web deletes the web-push token + the token-keyed doc instead
export const resetPushRegistration = async (uid: ID) => {
  // electron tokens come from the shell bridge — there is no web-push registration to delete
  const messaging = window.electron ? undefined : await initPushNotifications();
  if (messaging) {
    await deleteToken(messaging).catch((error) => {
      getErrorReporter().captureException(error, {
        tags: { source: 'reset-push-registration', op: 'web-push-cleanup' },
      });
    });
  }

  const cachedToken = getPushNotificationToken(uid);
  if (!cachedToken) {
    return;
  }

  await deletePushToken(cachedToken);
};
